<template>
   <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-8 align-self-center">
            <h2 class="mb-0">Site Level Risk Monitoring</h2>
        </div>
    </div>
    <div class="wrapper wrapper-content px-0">
        <div class="row">
            <div class="col-lg-4 pr-1">
                <div class="card site_risk">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="mb-0"> Data signal overview </h6>
                    </div>
                    <div class="card-body">
                            <div class="row">
                                <div class="col-lg-6 border-right" @click.prevent="totalSignalsClicked()">
                                    <div class="d-flex justify-content-between">
                                        <div class="" >
                                            <p class="mb-0">Total Signals :</p>
                                            <div class="risk-score risk-low">{{ totalSignals }}</div>
                                        </div>
                                    </div>
                                </div>     
                                <div class="col-lg-6" @click.prevent="flaggedSignalsClicked()">
                                        <p class="mb-0">Flagged Signals :</p>
                                        <div class="d-flex justify-content-start align-items-center">
                                            <div class="risk-score risk-high me-2"> {{ flaggedSignals }}</div>
                                            <span class="text-muted fg-perc"> {{ flaggedPercentage }}%</span> 
                                        </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 pl-1">
                <div class="card site_risk">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="mb-0"> Risk Overview </h6>
                    </div>
                    <div class="card-body">
                            <div class="kpi-tiles">
                                <div class="kpi-tile kpi-tile-total cursor-pointer" @click.prevent="totalRiskClicked()">
                                <strong>Total</strong><br />{{ totalRisks }}
                                </div>
                            
                                <div class="kpi-tile kpi-tile-high cursor-pointer" @click.prevent="highRiskClicked()">
                                <strong>High</strong><br />{{ highRisks }}
                                <span class="text-muted fg-perc"> ({{ highRiskPercentage }}%)</span> 
                                </div>
                            
                                <div class="kpi-tile kpi-tile-medium cursor-pointer" @click.prevent="mediumRiskClicked()">
                                <strong>Medium</strong><br />{{ mediumRisks }}
                                <span class="text-muted fg-perc"> ({{ mediumRiskPercentage }}%)</span> 

                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 mt-1">
                <div class="card site_risk">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="mb-0"> Risk Category Breakdown </h6>
                    </div>
                    <div class="card-body">
                        <div class="risk-br-grid">
                            <div class="card site_risk px-0" v-for="(categoryData, categoryName) in groupedRisks" :key="categoryName">
                                <div class="card-header bg-light d-flex justify-content-between">
                                    <h6 class="mb-0 text-dark">{{ categoryName }}</h6>
                                </div>
                                <div class="card-body px-2 py-0">
                                    <div class="row">
                                        <div class="col-lg-6 border-right" @click.prevent="HighCategoryRiskClicked(categoryData.high)">
                                            <p class="mb-0">High :</p>
                                            <div class="risk-score risk-high">
                                                {{ categoryData.high.length }}
                                            </div>
                                        </div>

                                        <div class="col-lg-6" @click.prevent="MediumCategoryRiskClicked(categoryData.medium)">
                                            <p class="mb-0">Medium :</p>
                                            <div class="d-flex align-items-center">
                                                <div class="risk-score risk-medium me-2">
                                                    {{ categoryData.medium.length }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 mt-1 pr-1">
                <div class="card site_risk">
                     <div class="card-header d-flex justify-content-between">
                        <h6 class="mb-0"> Data Signals </h6>
                    </div>
                
                <div class="card-body min-Height">
                    <div 
                        class="table-responsive" 
                        :class="{ 'scrollable-table': dataSignal?.length > 10 }">
                        <table class="table align-middle mb-0 studies-table">
                            <thead>
                                <tr>
                                    <th>Field</th>
                                    <th>Category</th>
                                    <th>Technique</th>
                                    <th>Observed metric</th>
                                    <th>Outcome</th>
                                    <th>Flag</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="signal in dataSignal" :key="signal.id">
                                    <td> {{ signal.fieldName }}</td>
                                    <td> {{ signal.catalogs[0].category }}</td>
                                    <td> {{ signal.linkedTechniqueCode }}</td>
                                    <td> {{ signal.observedMetric }}</td>
                                    <td> {{ signal.flagType }}</td>
                                    <td> {{ signal.flagged }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-lg-7 pl-1 mt-1">
                <div class="card site_risk">
                     <div class="card-header d-flex justify-content-between">
                        <h6 class="mb-0"> Risk Score </h6>
                    </div>
                
                <div class="card-body">
                    <div 
                        class="table-responsive" 
                        :class="{ 'scrollable-table': rirskData?.entities?.length > 10 }">
                        <table class="table align-middle mb-0 studies-table">
                            <thead>
                                <tr>
                                    <th> Category</th>
                                    <th> Sub-Category</th>
                                    <th> Risk Indicator</th>
                                    <th>Execution Type</th>
                                    <th> Probability</th>
                                    <th> Impact</th>
                                    <th> Detectability</th>
                                    <th> Risk Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="risk in rirskData.entities" :key="risk.id">
                                    <td> {{ risk.category }}</td>
                                    <td> {{ risk.subCategory }}</td>
                                    <td> {{ risk.riskIndicator }}</td>
                                    <td> {{ risk.executionType }}</td>
                                    <td> {{ risk.probabilityPoint }}</td>
                                    <td> {{ risk.impactPoint }}</td>
                                    <td> {{ risk.detectabilityPoint }}</td>
                                    <td> {{ risk.score }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
    <riskPopup 
        v-if="showRiskPop === true" 
        :requiredsite="false" 
        popupheadder="Risk Items" 
        :highriskitems="riskPopupData"
        @closeModal="closeRiskkpopup"
    />

    <dataSignalPopup 
        v-if="showDataSignalPopup" 
        :data="signalPopupData" 
        :heading= "signalHeading"
        @closeModal="closeDataSignalPopup()"
    />
</template>
<script src="./SiteRiskDashboard.js"></script>
<style scoped>

.text-primary {
    color: #0d6efd !important;
}
.text-info {
    color: #0dcaf0 !important;
}
.site_risk h6{
    font-size: .8rem !important;
    font-weight: 600;
    color: #007bff;
}
.card-header{
    padding: 0.5rem .5rem;
    font-size: 13px;
    font-weight: 600;
}
.risk-score {
  font-size: 28px;
  font-weight: 700;
}
.fg-perc {
  font-size: 14px;
}
.risk-high {
  color: #dc2626;
  background-color: transparent;
}

.risk-medium {
  color: #f59e0b;
  background-color: transparent;
}

.risk-low {
  color: #16a34a;
  background-color: transparent;
}

.kpi-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.kpi-tile {
  padding: 12px;
  border-radius: 8px;
  background: #f9fafb;
  border-left: 6px solid;
}

.kpi-tile-high {
  border-color: #dc2626;
}

.kpi-tile-medium {
  border-color: #f59e0b;
}
.kpi-tile-low {
  border-color: #16a34a;
}
.kpi-tile-total {
  border-color: #1c84c6;
}
.scrollable-table {
  max-height: 420px;
  overflow-y: auto;
}
.studies-table thead th {
  font-weight: 700;
  color: #111;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  padding-top: 5px;
  padding-bottom: 5px;
  white-space: nowrap;
}
.risk-br-grid {
    display: flex;             
    gap: 8px;
    overflow-x: auto;           
    flex-wrap: nowrap;          
    padding-bottom: 5px;        
}

.risk-br-grid .card {
    min-width: 220px;          
    flex-shrink: 0;          
}

.min-Height{
    min-height: 380px;
}
</style>
